import { loader } from 'graphql.macro'

export default async function invoicePaymentDetails ({ dataLoaders, queryKey }) {
  const [, id] = queryKey
  const schema = loader('./invoicePaymentDetails.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(schema, { id })
}
